import { useState, useEffect } from 'react';
import IExameLogo from './Logo.jsx';
import { Icon } from './Icons.jsx';
import Avatar from './Avatar.jsx';
import { getCatalog } from '../api/labs.js';
import { brl } from '../utils/format.js';

export default function LandingScreen({ onBuy, onSearch, onLogin, user, onOpenAccountMenu }) {
  const [top, setTop] = useState([]);

  useEffect(() => {
    getCatalog({ limit: 10 })
      .then(data => setTop(data || []))
      .catch(() => setTop([])); // API fora do ar: lista some, sem dados falsos
  }, []);

  return (
    <div className="screen" style={{ background: 'var(--bg)' }}>
      <div style={{ flex: 1, overflowY: 'auto', minHeight: 0, background: 'var(--bg)' }}>
      {/* hero */}
      <div style={{
        background: 'linear-gradient(160deg, var(--midnight) 0%, var(--midnight-90) 55%, var(--navy-3) 100%)',
        color: 'var(--white)', padding: '58px 22px 110px', position: 'relative', overflow: 'hidden',
      }}>
        <svg width="320" height="320" style={{ position: 'absolute', right: -110, top: -80, opacity: 0.18 }}>
          {[...Array(7)].map((_, i) => (
            <circle key={i} cx="160" cy="160" r={28 + i * 22} stroke="var(--brand-primary)" strokeWidth="1" fill="none"/>
          ))}
        </svg>

        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <IExameLogo size={28} color="var(--white)" accent="var(--brand-primary)"/>
            {user ? (
              <Avatar user={user} size={38} onClick={onOpenAccountMenu} style={{ border: '1px solid var(--overlay-white-35)' }}/>
            ) : (
              <button onClick={onLogin} style={{
                padding: '8px 14px', borderRadius: 99, fontSize: 12, fontWeight: 600,
                fontFamily: 'var(--font-display)', color: 'var(--white)',
                border: '1px solid var(--overlay-white-30)', background: 'var(--overlay-white-08)',
              }}>Entrar</button>
            )}
          </div>

          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 26,
            padding: '5px 11px', borderRadius: 99,
            background: 'var(--overlay-primary-18)', color: 'var(--primary-tint-text)',
            fontSize: 10, fontWeight: 700, letterSpacing: '0.08em',
            textTransform: 'uppercase', fontFamily: 'var(--font-display)',
          }}>
            <span style={{ width: 6, height: 6, borderRadius: 99, background: 'var(--brand-primary)' }}/>
            Exames clínicos · preço justo
          </div>

          <h1 style={{ fontSize: 30, fontWeight: 700, lineHeight: 1.12, marginTop: 14, color: 'var(--white)' }}>
            Seu exame.<br/>
            <span style={{ color: 'var(--brand-primary)' }}>Onde for mais barato.</span>
          </h1>
          <p style={{ marginTop: 12, fontSize: 14, lineHeight: 1.55, color: 'var(--overlay-white-78)', maxWidth: 320 }}>
            A gente compara o preço entre laboratórios da sua região e mostra de onde sair com o resultado certificado pagando menos.
          </p>

          <div style={{ display: 'flex', gap: 18, marginTop: 22 }}>
            {[
              { n: '+2.300', l: 'laboratórios' },
              { n: '−68%',   l: 'do preço médio' },
              { n: '24h',    l: 'resultado' },
            ].map((s, i) => (
              <div key={i}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, color: 'var(--white)' }}>{s.n}</div>
                <div style={{ fontSize: 10.5, color: 'var(--overlay-white-60)', textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: 2 }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* card top 10 — sobrepõe o hero */}
      <div style={{ padding: '0 16px', marginTop: -78, position: 'relative', zIndex: 2 }}>
        <div className="card" style={{ padding: '18px 16px 8px', boxShadow: '0 12px 30px var(--overlay-navy-10)' }}>
          <button onClick={onSearch} className="btn btn-primary" style={{ marginBottom: 16, minHeight: 52 }}>
            <Icon.search size={18}/> Pesquisar Exames
          </button>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 4 }}>
            <h2 style={{ fontSize: 17, fontWeight: 700 }}>Exames em destaque</h2>
          </div>
          <p style={{ fontSize: 12.5, color: 'var(--text-muted)', marginTop: 0, marginBottom: 10 }}>
            Preços "a partir de" — o menor encontrado nos laboratórios parceiros.
          </p>

          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {top.map((e, i) => (
              <ExamRow key={e.code} exam={e} rank={i + 1} onBuy={() => onBuy(e)}/>
            ))}
          </ul>
          {top.length === 0 && (
            <div style={{ fontSize: 13, color: 'var(--text-muted)', padding: '10px 0' }}>
              Use a busca para encontrar seu exame.
            </div>
          )}

          <button onClick={onSearch} className="btn btn-outline" style={{ margin: '14px 0 16px', minHeight: 52 }}>
            <Icon.search size={18}/> Pesquisar outros exames
          </button>
        </div>

        <PromiseBlock/>
        <div style={{ height: 28 }}/>
      </div>
      </div>
    </div>
  );
}

function ExamRow({ exam, rank, onBuy }) {
  return (
    <li style={{
      display: 'grid', gridTemplateColumns: '1fr auto', gap: 10, alignItems: 'center',
      padding: '14px 0', borderBottom: '1px solid var(--border)',
    }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{
            fontFamily: 'var(--font-display)', fontSize: 10.5, fontWeight: 700,
            color: 'var(--text-subtle)', minWidth: 18,
          }}>{String(rank).padStart(2, '0')}</span>
          <span style={{
            fontWeight: 600, fontSize: 14, color: 'var(--midnight)', lineHeight: 1.25,
            overflow: 'hidden', textOverflow: 'ellipsis',
          }}>{exam.name}</span>
        </div>
        <div style={{ marginLeft: 26, marginTop: 3, display: 'flex', alignItems: 'baseline', gap: 6 }}>
          <span style={{ fontSize: 10.5, color: 'var(--text-subtle)', textTransform: 'uppercase', letterSpacing: '0.04em', fontFamily: 'var(--font-display)' }}>
            a partir de
          </span>
          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, color: 'var(--brand-primary)' }}>
            R$ {brl(exam.price)}
          </span>
        </div>
      </div>
      <button onClick={onBuy} style={{
        padding: '9px 16px', borderRadius: 99,
        background: 'var(--midnight)', color: 'var(--white)',
        fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13,
        minHeight: 38, display: 'inline-flex', alignItems: 'center', gap: 6,
      }}>
        Comprar <Icon.arrowR size={14} color="var(--white)"/>
      </button>
    </li>
  );
}

function PromiseBlock() {
  const items = [
    { ic: 'shield', t: 'Laboratórios verificados', d: 'Todos com certificação PALC ou ISO 15189.' },
    { ic: 'pin',    t: 'Perto de você',            d: 'Mostramos as unidades em até 5 km do seu CEP.' },
    { ic: 'clock',  t: 'Resultado em até 24h',      d: 'Direto no app — sem precisar voltar ao laboratório.' },
  ];
  return (
    <div style={{ marginTop: 16 }}>
      <h3 style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10, fontFamily: 'var(--font-display)' }}>
        Por que iExame
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {items.map((it, i) => {
          const IC = Icon[it.ic];
          return (
            <div key={i} className="card" style={{ padding: '12px 14px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <div style={{
                width: 36, height: 36, borderRadius: 10,
                background: 'var(--brand-primary-soft)', color: 'var(--brand-primary)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              }}>
                <IC size={18} color="var(--brand-primary)"/>
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13.5, color: 'var(--midnight)' }}>{it.t}</div>
                <div style={{ fontSize: 12.5, color: 'var(--text-muted)', marginTop: 1, lineHeight: 1.4 }}>{it.d}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
